import type { BusinessLinkItem, UserPoliciesListItem } from '../types/serviceType';

export function policyListRowKey(row: UserPoliciesListItem, index: number): string {
  const k = row.identContrato ?? row.identContratoApol ?? row.numApoliceApol;
  return k != null ? String(k) : `idx-${index}`;
}

export function businessLinkRowKey(v: BusinessLinkItem): string {
  return String(v.representacao?.id ?? v.idVinculoNegocio);
}

/** Product filter for listar-vinculo (4=Life, 5=Pension). */
export function selectedTypeToProductId(type: 'vida' | 'previdencia' | null): number {
  if (type === 'previdencia') return 5;
  return 4;
}
